export const createAdapter = (name) => (storage) => ({
    save: (state) => {
        storage.setItem(name, JSON.stringify(state));
    },
    load: () => {
        try {
            return JSON.parse(storage.getItem(name) ?? '{}');
        }
        catch (e) {
            return {};
        }
    }
});
export const init = (name, window) => createAdapter(name)(window.localStorage);
